import { SVGIconComponent } from './types';

export const Reload: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Action/Sync" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M12.9965439,5.0009433 C8.5871934,5.0009433 5,8.5882894 5,12.9973996 C5,17.4065099 8.5873854,21 12.9965439,21 C17.4057025,21 21,17.4067019 21,12.9973996 C21,12.7161566 20.9827497,12.4378896 20.9534988,12.1581442 L20.9527488,12.1588943 C20.9309987,11.9473861 20.8259961,11.7531387 20.6610001,11.6188916 C20.4959965,11.4853914 20.2845013,11.4223978 20.0729907,11.44414 C19.6342253,11.4921403 19.3169786,11.8858959 19.3634818,12.3238885 C19.3867314,12.5473968 19.3994824,12.7723835 19.3994824,12.9973895 C19.3994824,16.5419193 16.5411326,19.4002378 12.9965639,19.4002378 C9.4519952,19.4002378 6.59518149,16.5419193 6.59518149,12.9973895 C6.59518149,9.45285958 9.4519952,6.59607717 12.9965639,6.59607717 C14.4755828,6.59607717 15.8915862,7.10532134 17.0203723,8.01657714 L15.9156058,9.12133151 L15.9148559,9.12133151 C15.8031043,9.23608281 15.7701028,9.40708655 15.8323541,9.55483129 C15.8938546,9.70333252 16.0386038,9.80007413 16.1991183,9.80082294 L19.3994255,9.80082294 C19.6199219,9.80157289 19.7991759,9.62382108 19.8006735,9.40407213 L19.8006735,6.20226398 C19.8014235,6.03951244 19.7031725,5.89250882 19.5524136,5.83026211 C19.5111636,5.81301197 19.466162,5.80251221 19.4211622,5.80026196 C19.3071604,5.79426193 19.195405,5.83776167 19.1151477,5.91876303 L18.1513883,6.8825119 C16.7218678,5.67876182 14.9000083,5 12.9964898,5 L12.9965439,5.0009433 Z"
        id="Path"
        fill="#848484"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
